import { render, staticRenderFns } from "./TakeoutConfig.vue?vue&type=template&id=82f07f90&scoped=true"
import script from "./TakeoutConfig.vue?vue&type=script&lang=js"
export * from "./TakeoutConfig.vue?vue&type=script&lang=js"
import style0 from "./TakeoutConfig.vue?vue&type=style&index=0&id=82f07f90&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f07f90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82f07f90')) {
      api.createRecord('82f07f90', component.options)
    } else {
      api.reload('82f07f90', component.options)
    }
    module.hot.accept("./TakeoutConfig.vue?vue&type=template&id=82f07f90&scoped=true", function () {
      api.rerender('82f07f90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/components/form/TakeoutConfig.vue"
export default component.exports